module.exports = __webpack_public_path__ + "/login_ui/img/rw-23704412d99018951bdaa68eae3e7a1b.svg";